var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup3084(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3084",
    "data-name": "Group 3084",
    transform: "translate(-21527 23788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    transform: "translate(21527 -23788)",
    fill: "#f98525",
    stroke: "#061133",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 28,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 27.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    transform: "translate(21529.5 -23785.5)",
    fill: "#f5f5f5",
    stroke: "#061133",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 7.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    transform: "translate(21529.5 -23770.5)",
    fill: "#f5f5f5",
    stroke: "#061133",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 7.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3081",
    "data-name": "Group 3081",
    transform: "translate(21532.598 -23777.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M0,0H6.578",
    transform: "translate(1.904 0) rotate(90)",
    fill: "none",
    stroke: "#061133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M0,0,1.9,1.9,0,3.807",
    transform: "translate(3.807 4.675) rotate(90)",
    fill: "none",
    stroke: "#061133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3084);
export default __webpack_public_path__ + "static/media/Group 3084.e120a8217e0fed38025e900e76e31506.svg";
export { ForwardRef as ReactComponent };